module.exports = __webpack_public_path__ + "assets/65e66b45e90a52a520b85f109f9d350e.png";